import { render } from "./sucursalForm.vue?vue&type=template&id=780d12d2&scoped=true"
import script from "./sucursalForm.vue?vue&type=script&lang=js"
export * from "./sucursalForm.vue?vue&type=script&lang=js"

import "./sucursalForm.vue?vue&type=style&index=0&id=780d12d2&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-780d12d2"]])

export default __exports__